function cachePlugin() {
  var cache = new WeakMap();

  function onCreateRule(name, decl, _ref) {
    var parent = _ref.parent;
    return parent && name ? cache.get(parent.rules.raw[name]) || null : null;
  }

  function onProcessRule(rule) {
    var _rule$options = rule.options,
        sheet = _rule$options.sheet,
        parent = _rule$options.parent;

    if (!parent || sheet && sheet.options.link) {
      return;
    }

    var originalStyle = parent.rules.raw[rule.key];
    if (!cache.get(originalStyle)) cache.set(originalStyle, rule);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

export default cachePlugin;
